import formErrors from 'constants/formErrors';
import joi from 'joi';
import { InputsEnum } from 'types/dynamicInputs';
import { TextInputTypes } from 'types/dynamicInputs';

export default {
  workersNeeded: {
    value: 10,
    label: 'Workers needed',
    limit: 3,
    input: InputsEnum.COUNTER,
    joi: joi
      .number()
      .max(250)
      .required()
      .messages({
        'number.base': formErrors.REQUIRED,
        'number.max': formErrors.MAX(250)
      })
  },
  reportTime: {
    value: '',
    label: 'Report time',
    input: InputsEnum.INPUT,
    type: TextInputTypes.TEXT,
    required: false,
    joi: joi
      .string()
      .pattern(/^([0-1]\d|2[0-3]):([0-5]\d)$/)
      .allow('')
      .messages({
        'string.pattern.base': 'Format must be HH:mm'
      })
  }
};
